// DESIGN SYSTEM: "LIGHT PREMIUM"
// Warm grey/beige with blue accents — clean factory floor app.

export const DS = {
  // 1. GLOBAL LAYOUT
  layout: {
    bg: "bg-stone-50",         // Warm beige/grey background
    text: "text-slate-900",
    textMuted: "text-slate-500",
    header: "bg-white pt-safe sticky top-0 z-40 px-6 pb-2 border-b border-slate-200/60",
    glass: "bg-white/90 backdrop-blur-xl border-b border-slate-200/60",
  },

  // 2. CARDS
  card: {
    container: "bg-white border border-slate-200/80 rounded-2xl p-5 relative overflow-hidden active:scale-[0.98] transition-transform duration-200 shadow-sm shadow-slate-200/50",
    highlight: "bg-blue-50/50 border border-blue-100 rounded-2xl p-5 shadow-sm",
    header: "flex justify-between items-start mb-4",
    body: "",
  },

  // 3. INTERACTIVE ELEMENTS
  button: {
    primary: "bg-blue-600 text-white rounded-2xl py-4 px-8 font-bold text-center shadow-md shadow-blue-600/20 active:scale-95 transition-all w-full",
    secondary: "bg-slate-100 border border-slate-200 text-slate-600 rounded-2xl py-3 px-6 font-medium text-sm flex items-center justify-center gap-2 active:bg-slate-200 transition-colors",
    icon: "w-10 h-10 rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center text-slate-600 active:bg-slate-200 transition-colors",
    action: "w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center text-white shadow-xl shadow-blue-600/30 active:scale-90 transition-transform border-4 border-white",
  },

  // 4. TYPOGRAPHY
  type: {
    headingBig: "text-3xl font-bold tracking-tight text-slate-900",
    headingMedium: "text-xl font-bold tracking-tight text-slate-800",
    headingSmall: "text-sm font-semibold text-slate-500 uppercase tracking-wider",
    label: "text-xs font-bold text-slate-400 uppercase tracking-widest",
    body: "text-sm text-slate-600 font-medium",
    value: "text-2xl font-mono font-medium text-slate-900",
  },

  // 5. STATUS INDICATORS
  status: {
    base: "inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-wide border",
    neutral: "bg-slate-100 border-slate-200 text-slate-500",
    brand: "bg-blue-50 border-blue-200 text-blue-600",
    success: "bg-emerald-50 border-emerald-200 text-emerald-600",
    warning: "bg-amber-50 border-amber-200 text-amber-600",
    error: "bg-red-50 border-red-200 text-red-600",
    purple: "bg-purple-50 border-purple-200 text-purple-600",
  },

  // 6. FORMS
  input: {
    base: "w-full bg-slate-50 border border-slate-200 rounded-xl px-5 py-4 text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-300 transition-all font-medium",
    label: "block text-xs font-bold text-slate-500 mb-2 ml-1",
  }
};